import {
  Button,
  Callout,
  Div,
  H3,
  Img,
  P,
  getStartedVDrive,
} from '@vgrubs/components';
import { Dispatch, SetStateAction } from 'react';

export const GetStartedVDrive = ({
  setStep,
  rejectionReason,
}: {
  setStep: Dispatch<SetStateAction<number>>;
  /** Why an admin rejected the last request, when that is why we are here. */
  rejectionReason?: string | null;
}) => {
  return (
    <Div $flex $column $alignCenter>
      <Img alt="" $width="200px" $mb="40" src={getStartedVDrive} />

      {rejectionReason && (
        <Div $width="100%" $mb="24">
          <Callout tone="danger">
            <P $m="0">
              <b>The last vDrive request was rejected.</b>
              <br />
              {rejectionReason}
            </P>
          </Callout>
        </Div>
      )}

      <H3 $center $m="8px 0 24px 0">
        Get Started with vDrive
      </H3>

      <P $center $mb="0">
        Activate client’s vDrive without any obligation in 3 simple steps and
        the client will receive a <span>free $10</span> balance that he can use
        to deliver orders.
        <br />
        <br />
        Once you are ready, click on Get Started below to add the card on file
        for client’s deliveries.
      </P>

      <Button
        $selected
        $w="100%"
        $wSM="100%"
        $mt="24"
        onClick={() => setStep(1)}
      >
        Get Started
      </Button>

      <a
        href="https://vgrubs.com/vdrive"
        target="_blank"
        rel="noopener noreferrer"
        style={{ width: '100%' }}
      >
        <Button
          $selected
          $w="100%"
          $wSM="100%"
          $mt="16"
          // onClick={handleSubmitStripe}
          $darkBlue
        >
          Learn More About vDrive
        </Button>
      </a>
    </Div>
  );
};
